/**
 * Scene Style01 - Scene trigger button
 */
import type { TraitControlProps } from './types'

export function SceneStyle01({ state, onCommand, disabled = false }: TraitControlProps) {
  const sceneName = (state?.sceneName ?? state?.scene ?? state?.name ?? 'Scene') as string

  return (
    <div className="smart-home-automation-field">
      <label>Scene</label>
      <button
        type="button"
        className="smart-home-automation-command-btn glass"
        onClick={() => onCommand('activateScene', { scene: sceneName })}
        disabled={disabled}
      >
        <span className="material-symbols-outlined">movie_creation</span>
        {sceneName}
      </button>
    </div>
  )
}
